/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_Waiting_For_Wifi_MessageInputs */

const en_mobile_download_waiting_for_wifi_message = /** @type {(inputs: Mobile_Download_Waiting_For_Wifi_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This download starts when you connect to Wi-Fi. You can download it now using cellular data instead.`)
};

const es_mobile_download_waiting_for_wifi_message = /** @type {(inputs: Mobile_Download_Waiting_For_Wifi_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta descarga empezará cuando te conectes a una red Wi-Fi. También puedes descargarla ahora con datos móviles.`)
};

/**
* | output |
* | --- |
* | "This download starts when you connect to Wi-Fi. You can download it now using cellular data instead." |
*
* @param {Mobile_Download_Waiting_For_Wifi_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_waiting_for_wifi_message = /** @type {((inputs?: Mobile_Download_Waiting_For_Wifi_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_Waiting_For_Wifi_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_waiting_for_wifi_message(inputs)
	return en_mobile_download_waiting_for_wifi_message(inputs)
});